

































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Icon } from '../icon-interface';

@Component
export default class NameComponent extends Vue {
  @Prop({
    type: Object
  })
  value: Icon | any;

  show_copyed = false;

  get copy_text() {
    return this.show_copyed
      ? `Copied:\n ${this.str}`
      : 'Click and copy\nto clipboard';
  }

  get str() {
    return `<i class="material-icons">${this.value.ligature}</i>`;
  }

  get ico() {
    return '&#x' + this.value.codepoint;
  }

  copy() {
    (this.$refs.input as HTMLInputElement).blur();
    this.$nextTick(() => {
      (this.$refs.input as HTMLInputElement).select();
      document.execCommand('copy');
    });

    this.show_copyed = true;

    setTimeout(() => {
      this.show_copyed = false;
    }, 3000);
  }

  close() {
    this.$emit('input', {});
  }
}
